<template>
  <div id="user_info">
    <el-container>
      <el-header><i class="far fa-address-card"></i> 登録情報</el-header>
      <el-main>
      <el-form ref="refFrmUserInfo" :model="frmUserInfo" :rules="rules" label-width="160px">
        <el-form-item label="御社名（法人の場合）">
          <el-input placeholder="ポストエクスプレス株式会社" v-model="frmUserInfo.corporate_name"></el-input>
        </el-form-item>
        <el-form-item label="郵便番号" prop="postal_code">
          <el-input placeholder="370-0042" v-model="frmUserInfo.postal_code"></el-input>
        </el-form-item>
        <el-form-item label="住所" prop="address">
          <el-input placeholder="群馬県高崎市貝沢町496-1" v-model="frmUserInfo.address"></el-input>
        </el-form-item>
        <el-form-item label="電話番号" prop="tel">
          <el-input placeholder="050-3851-1095" v-model="frmUserInfo.tel"></el-input>
        </el-form-item>
        <el-form-item label="業種" prop="business">
          <el-cascader
            v-model="frmUserInfo.business"
            :options="options"
            :props="{ expandTrigger: 'hover' }"
            @change="handleChange">
          </el-cascader>
        </el-form-item>
        <el-form-item label="ご担当者名" prop="person_charge">
          <el-input placeholder="群馬太郎" v-model="frmUserInfo.person_charge"></el-input>
        </el-form-item>
        <el-form-item label="メールアドレス" prop="mail_address">
          <el-input placeholder="user@example.com" v-model="frmUserInfo.mail_address"></el-input>
          <i class="fas fa-exclamation-circle" v-if="frmUserInfo.conf_flg==0" style="color:red" title="到達未確認"></i>
          <i class="fas fa-check-circle" v-if="frmUserInfo.conf_flg==1" style="color:green"></i>
        </el-form-item>
        <el-form-item label="パスワード" prop="password">
          <el-input placeholder="8文字以上" v-model="frmUserInfo.password" show-password autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="パスワード（確認）" prop="checkPass">
          <el-input placeholder="確認のため再入力してください。" v-model="frmUserInfo.checkPass" show-password autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-alert :title="message.msg" type="error" v-if="message.err"></el-alert>
          <el-alert :title="message.msg" type="success" v-if="!message.err && message.msg"></el-alert>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('frmUserInfo')">更新</el-button>
          <el-button type="info" @click="cancel()">戻る</el-button>
          <el-button type="success" v-if="frmUserInfo.mail_address != '' && frmUserInfo.conf_flg==0" @click="confmail()">確認用メール送信</el-button>
        </el-form-item>
      </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { business_options } from '@/business';
import { clsUser } from '@/types/clsUser';
import { clsUserInfo } from '@/types/clsUserInfo';
import { app } from '../main';

export default defineComponent({
  props: ['user'],
  setup(props, context) {
    const router = useRouter()
    if(!props.user.login) {
      console.log('Can\'t access UserInfo for not login.')
      router.back()
    }
    const refFrmUserInfo: any = ref(null)
    const loginUser = new clsUser()
    const frmUserInfo: clsUserInfo = reactive(new clsUserInfo())
    const message = reactive({
      msg: '',
      err: false,
      clear() {
        this.msg = '';
        this.err = false;
      },
    })
    const options = business_options
    const validatePass1 = (rule: any, value: string, callback: any) => {
      if(value !== '') {
        if(value.length < 8) {
        callback(new Error('パスワードは8文字以上入力してください。'));
        }else {
          callback();
        }
      }else {
        callback();
      }
    }
    const validatePass2 = (rule: any, value: string, callback: any) => {
      if(value === '' && frmUserInfo.password !== '') {
        callback(new Error('確認用パスワードを入力してください。'));
      }else if(value !== frmUserInfo.password) {
        callback(new Error('2回入力されたパスワードが一致しません。'));
      }else {
        callback();
      }
    }
    const	rules = {
      postal_code: [
        { required: true, message: '郵便番号を入力してください。', trigger: 'blur' },
        { min: 8, message: '文字数が不足しています（123-4567）。', trigger: 'blur' }
      ],
      address: [
        { required: true, message: '住所を入力してください。', trigger: 'blur' },
      ],
      tel: [
        { required: true, message: '電話番号を入力してください。', trigger: 'blur' },
        { min: 8, message: 'Length should be 8', trigger: 'blur' }
      ],
      business: [
        { required: true, message: '業種を選択してください。', trigger: 'change' }
      ],
      person_charge: [
        { required: true, message: 'ご担当者名を入力してください。', trigger: 'blur' },
      ],
      mail_address: [
        { required: true, message: 'メールアドレスを入力してください。', trigger: 'blur' },
      ],
      password: [
        { validator: validatePass1, trigger: 'blur' }
      ],
      checkPass: [
        { validator: validatePass2, trigger: 'blur' }
      ],
    }
    const	cancel = () => {
      message.clear();
      router.push({ path: '/mypage' });
    }
    const handleChange = (value: any) => {
      console.log(value);
    }
    const getUserInfo = () => {
      const api_path = app.config.globalProperties.api_path
      fetch(api_path + 'ajax/mypage.php', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(json => {
        //console.log(json);
        if(json['result'] == 'failure') {
          frmUserInfo.clear()
          if(json['err_code'] == 9) {
            context.emit('login', new clsUser())
          }
          throw new Error(json.error)
        }
        frmUserInfo.person_charge = json['person']
        frmUserInfo.mail_address = json['email']
        frmUserInfo.corporate_name = json['company']
        frmUserInfo.postal_code = json['zipcode']
        frmUserInfo.address = json['address']
        frmUserInfo.tel = json['telno']
        frmUserInfo.business = json['business']
        frmUserInfo.csrf = props.user.csrf
        frmUserInfo.conf_flg = json['conf_flg']
        frmUserInfo.mail_backup = json['email']
      })
      .catch(error => {
        console.error(error)
        message.msg = error.message
        message.err = true;
      });
    }
    const submitForm = () => {
      refFrmUserInfo.value.validate((valid: boolean) => {
        if(valid) {
          const api_path = app.config.globalProperties.api_path
          fetch(api_path + 'ajax/update_user.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(frmUserInfo)
          })
          .then(response => response.json())
          .then(json => {
            //console.log(json);
            if(json['result'] == 'failure') {
              throw new Error(json.error)
            }
            if(json['affected_rows'] > 0) {
              message.msg = "更新しました。";
              message.err = false;
              loginUser.login = props.user.login
              loginUser.name = frmUserInfo.person_charge,
              loginUser.admin_flg = props.user.admin_flg
              loginUser.validmail = (json['conf_flg'] == 1)
              context.emit('login', loginUser);
              frmUserInfo.conf_flg = loginUser.validmail
              if(json['conf_flg'] == '0') {
                app.config.globalProperties.$notify.info({
                  title: 'Info',
                  message: 'メールアドレス確認用のメールを送信しました。'
                });
              }
            }else {
              message.clear()
              console.log('Nothing to be update.')
            }
          })
          .catch(error => {
            console.error(error)
            message.msg = error.message
            message.err = true;
          })
        }
      })
    }
    getUserInfo()

    return {
      refFrmUserInfo,
      frmUserInfo,
      options,
      rules,
      handleChange,
      submitForm,
      cancel,
      message
    }
  }
})
</script>

<style>
#user_info {
  height: calc(100% - 69px);
  background-color: #ecf0f5;
  position: relative;
  overflow: auto;
}
#user_info .el-form {
  text-align: left;
}
#user_info .el-header {
  padding-top: 30px;
  color: #6f6f6f;
  font-size: larger;
  text-align: center;
}
#user_info .el-container {
  width: 600px;
  margin: 0 auto;
}
#user_info .el-input {
  width: 92%;
}
#user_info .el-cascader {
  width: 100%;
}
#user_info .el-form-item__content i {
  margin-left: 7px;
}
</style>